import React from 'react'


const myStyle = {
  color: "white",
  padding: "10px",
  margin: "100px",
  fontFamily: "Sans-Serif",
  fontSize: "6rem",
};
const Notfound = () => {
  return (
    <>
      <h1 style={myStyle}>404 NOT FOUND PLS GO TO THE HOME PAGE</h1>
    </>
  )
}

export default Notfound
